import React, { useState, useCallback } from 'react';
import MobileMapToggle from './MobileMapToggle';
import GoogleMapSection from './GoogleMapSection';

const HotelsMap = ({
  viewFullWidhtMap,
  isMobile,
  mapCenter,
  handleCloseModal,
  hoveredHotel,
  id_site,
  business_types,
  totalNights,
  setIsLoadImage,
  handleModal,
  handleMapFullWidth,
  showModal,
  handleChangePage,
  hotel,
  isLoadImage,
  allFilteredHotels,
  getFavConfig,
  getFormattedPrice,
  mapTarget,
}) => {
  const [expandMap, setExpandMap] = useState(false);

  const handleExpandMap = useCallback(value => {
    setExpandMap(value);
  }, []);

  return (
    <>
      <GoogleMapSection
        mapCenter={mapCenter}
        isMobile={isMobile}
        viewFullWidhtMap={viewFullWidhtMap}
        hoveredHotel={hoveredHotel}
        id_site={id_site}
        setIsLoadImage={setIsLoadImage}
        handleModal={handleModal}
        showModal={showModal}
        hotel={hotel}
        handleCloseModal={handleCloseModal}
        handleChangePage={handleChangePage}
        isLoadImage={isLoadImage}
        handleMapFullWidth={handleMapFullWidth}
        allFilteredHotels={allFilteredHotels}
        business_types={business_types}
        totalNights={totalNights}
        getFavConfig={getFavConfig}
        getFormattedPrice={getFormattedPrice}
        expandMap={expandMap}
        mapTarget={mapTarget}
      />
      {isMobile && (
        <MobileMapToggle
          expandMap={expandMap}
          handleExpandMap={handleExpandMap}
        />
      )}
    </>
  );
};

export default HotelsMap;
